import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseConfig";
import { getAuth } from 'firebase/auth';

export async function fetchVehicleData(deviceId) {
    if (!deviceId) {
        console.error("Device ID is missing!");
        return null;
    }

    const auth = getAuth();
    console.log('flespiApi.js - Current user before API call:', auth.currentUser ? auth.currentUser.uid : 'No user');

    const fetchVehicleLocations = httpsCallable(functions, "fetchVehicleLocations");
    try {
        const result = await fetchVehicleLocations({ devices: [deviceId] });
        const data = result.data;
        if (!data.result || data.result.length === 0) {
            console.warn(`No data found for Device ID: ${deviceId}`);
            return null;
        }

        const vehicleData = data.result[0];

        return {
            imei: vehicleData.ident || "N/A",
            location:
                vehicleData["position.latitude"] && vehicleData["position.longitude"]
                    ? `${vehicleData["position.latitude"]}, ${vehicleData["position.longitude"]}`
                    : "N/A",
            lat: vehicleData["position.latitude"] || null,
            lng: vehicleData["position.longitude"] || null,
            speed: vehicleData["position.speed"] !== undefined ? `${vehicleData["position.speed"]}` : "N/A",
            direction: vehicleData["position.direction"] || 0,
            movement: vehicleData["movement.status"] ? "Moving" : "Stopped",
            externalBattery:
                vehicleData["external.powersource.voltage"] !== undefined
                    ? `${vehicleData["external.powersource.voltage"]}`
                    : "N/A",
            internalBattery:
                vehicleData["battery.level"] !== undefined ? `${vehicleData["battery.level"]}` : "N/A",
            lastUpdateTime: vehicleData.timestamp
                ? new Date(vehicleData.timestamp * 1000).toLocaleString()
                : "N/A",
            lockedStatus: vehicleData["dout.1"] ? "Locked" : "Unlocked",
            ignitionStatus: vehicleData["din.1"] ? "On" : "Off",
            soc: parseSOC(vehicleData["can.data.frame.1"]),
            isOffline: Date.now() - (vehicleData.timestamp * 1000) > 24 * 60 * 60 * 1000,
        };
    } catch (error) {
        console.error(`Error fetching data for Device ID: ${deviceId}:`, error.message);
        return null;
    }
}

function parseSOC(hexString) {
    if (!hexString || hexString.length < 10) return "N/A";
    const fifthByte = hexString.slice(8, 10);
    return `${parseInt(fifthByte, 16)}`;
}